



































import { computed, defineComponent } from "@vue/composition-api";

type Props = {
  type: string;
  fixed: boolean;
  scroll: boolean;
  tableSize: "small" | "medium";
  hideBottomBorder: boolean;
  width: string;
};

export default defineComponent({
  name: "OccTable",
  props: {
    type: {
      type: String,
      default: "standard"
    },
    fixed: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideBottomBorder: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium",
      validator(value: string) {
        return ["small", "medium"].includes(value);
      }
    },
    width: {
      type: String,
      default: ""
    }
  },
  setup(props: Props) {
    const styles = computed(() => {
      return {
        width: props.width ? props.width : undefined
      };
    });
    return { styles };
  }
});
